import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCheckbox = ({
  fill = '#121212',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 0H5C2.23858 0 0 2.23858 0 5V15C0 17.7614 2.23858 20 5 20H15C17.7614 20 20 17.7614 20 15V5C20 2.23858 17.7614 0 15 0Z"
      fill={fill}
    />
    <path
      d="M8.53553 10.714L6.17851 8.35702L5 9.53553L8.53553 13.0711L14.4281 7.17851L13.2496 6L8.53553 10.714Z"
      fill="white"
    />
  </svg>
);
export default SvgCheckbox;
